// As strings do voucher de aluguel de carro no esqueleto novo (`buildRentalVoucherView`,
// #5032), em arquivo próprio pelo mesmo motivo do `hotel_voucher_catalog.ts`: o catálogo
// principal tem teto de 500 linhas. O `CATALOG` espalha estas três por cima das dele.
const PT_BR = {
  'trips.rentalVoucher.title': 'Aluguel de carro',
  'trips.rentalVoucher.dates': 'Retirada · {{date}}',
  'trips.rentalVoucher.dailies_one': '{{count}} diária',
  'trips.rentalVoucher.dailies_other': '{{count}} diárias',
  'trips.rentalVoucher.dropoffStore': 'Loja de devolução',
  'trips.rentalVoucher.vehicle': 'Veículo',
  'trips.rentalVoucher.transmission.MANUAL': 'Manual',
  'trips.rentalVoucher.transmission.AUTOMATIC': 'Automático',
  'trips.rentalVoucher.airConditioning': 'Ar-condicionado',
  'trips.rentalVoucher.orSimilar': '{{model}} ou similar',
  'trips.rentalVoucher.damageProtection': 'Proteção contra avarias incluída',
  'trips.rentalVoucher.glassAndTireProtection': 'Proteção de vidros e pneus incluída',
  'trips.rentalVoucher.extrasNote': 'Despesas extras geram um novo voucher.',
  'trips.rentalVoucher.dailyRate': 'Diária',
  'trips.rentalVoucher.days': 'Nº de diárias',
};

const EN: Record<keyof typeof PT_BR, string> = {
  'trips.rentalVoucher.title': 'Car rental',
  'trips.rentalVoucher.dates': 'Pick-up · {{date}}',
  'trips.rentalVoucher.dailies_one': '{{count}} day',
  'trips.rentalVoucher.dailies_other': '{{count}} days',
  'trips.rentalVoucher.dropoffStore': 'Drop-off store',
  'trips.rentalVoucher.vehicle': 'Vehicle',
  'trips.rentalVoucher.transmission.MANUAL': 'Manual',
  'trips.rentalVoucher.transmission.AUTOMATIC': 'Automatic',
  'trips.rentalVoucher.airConditioning': 'Air conditioning',
  'trips.rentalVoucher.orSimilar': '{{model}} or similar',
  'trips.rentalVoucher.damageProtection': 'Damage protection included',
  'trips.rentalVoucher.glassAndTireProtection': 'Glass and tire protection included',
  'trips.rentalVoucher.extrasNote': 'Extra charges generate a new voucher.',
  'trips.rentalVoucher.dailyRate': 'Daily rate',
  'trips.rentalVoucher.days': 'No. of days',
};

const ES: Record<keyof typeof PT_BR, string> = {
  'trips.rentalVoucher.title': 'Alquiler de auto',
  'trips.rentalVoucher.dates': 'Retiro · {{date}}',
  'trips.rentalVoucher.dailies_one': '{{count}} día',
  'trips.rentalVoucher.dailies_other': '{{count}} días',
  'trips.rentalVoucher.dropoffStore': 'Tienda de devolución',
  'trips.rentalVoucher.vehicle': 'Vehículo',
  'trips.rentalVoucher.transmission.MANUAL': 'Manual',
  'trips.rentalVoucher.transmission.AUTOMATIC': 'Automático',
  'trips.rentalVoucher.airConditioning': 'Aire acondicionado',
  'trips.rentalVoucher.orSimilar': '{{model}} o similar',
  'trips.rentalVoucher.damageProtection': 'Protección contra daños incluida',
  'trips.rentalVoucher.glassAndTireProtection': 'Protección de cristales y neumáticos incluida',
  'trips.rentalVoucher.extrasNote': 'Los gastos extra generan un nuevo voucher.',
  'trips.rentalVoucher.dailyRate': 'Tarifa diaria',
  'trips.rentalVoucher.days': 'N.º de días',
};

export const RENTAL_VOUCHER_CATALOG = { 'pt-BR': PT_BR, en: EN, es: ES };
